import React from 'react';
import { CreditCard } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050810] py-12 border-t border-white/5" data-id="element-32">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-33">
        <div className="flex flex-col items-center gap-6 text-center" data-id="element-34">
          <div className="font-playfair text-2xl font-black text-gradient-gold" data-id="element-35">
            Reflujo Cero en 72h
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-36">
            <div className="flex gap-3 items-center flex-wrap justify-center text-text-muted" data-id="element-37">
              <CreditCard className="w-6 h-6" data-id="element-38" />
              <span className="text-sm font-medium" data-id="element-39">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-3 flex-wrap justify-center" data-id="element-40">
              <span className="text-[10px] font-bold text-text-muted/60 bg-white/5 rounded px-2 py-0.5" data-id="element-41">
                VISA
              </span>
              <span className="text-[10px] font-bold text-text-muted/60 bg-white/5 rounded px-2 py-0.5" data-id="element-42">
                MASTERCARD
              </span>
              <span className="text-[10px] font-bold text-text-muted/60 bg-white/5 rounded px-2 py-0.5" data-id="element-43">
                AMEX
              </span>
              <span className="text-[10px] font-bold text-text-muted/60 bg-white/5 rounded px-2 py-0.5" data-id="element-44">
                PAYPAL
              </span>
              <span className="text-[10px] font-bold text-text-muted/60 bg-white/5 rounded px-2 py-0.5" data-id="element-45">
                PIX
              </span>
            </div>
            <p className="text-[11px] text-text-muted/50" data-id="element-46">
              Procesado por Hotmart® — Conexión cifrada SSL 256-bit
            </p>
          </div>

          <div className="flex gap-6 flex-wrap justify-center" data-id="element-47">
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-48">
              Términos y Condiciones
            </a>
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-49">
              Política de Privacidad
            </a>
            <a href="#garantia" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-50">
              Política de Reembolso
            </a>
            <a href="#" className="text-text-muted text-sm no-underline transition-colors hover:text-accent" data-id="element-51">
              Contacto
            </a>
          </div>

          <p className="text-text-muted text-xs max-w-3xl leading-relaxed" data-id="element-52">
            <strong data-id="element-53">Aviso Legal:</strong> Este producto es de carácter educativo
            e informativo. No reemplaza la evaluación, diagnóstico ni
            tratamiento médico profesional. Si presentas síntomas graves como
            dolor intenso, dificultad para tragar, sangrado, pérdida de peso
            inexplicada o cualquier condición gastrointestinal diagnosticada,
            consulta con tu médico antes de aplicar cualquier protocolo. Los
            resultados individuales pueden variar.
          </p>

          <p className="text-white/20 text-xs" data-id="element-54">
            © {new Date().getFullYear()} Hugo Pagano — Reflujo Cero en 72h.
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}